<div class="facility-list__title">
  {{ title }}
</div>

<div class="facility-list__body">
  @for (facility of facilities; track facility) {
  <app-facility-card [facility]="facility"> </app-facility-card>
  }
</div>
